module.exports = __webpack_public_path__ + "static/img/r_018.dd59282.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic/r_018.jpg
// module id = +chB
// module chunks = 1